module.exports = __webpack_public_path__ + "img/img_4.ef9d5267.jpg";